/**
 * Hàm thuần cho khối "Số lượt truy cập hệ thống" trên Dashboard.
 * Tách khỏi component để unit test được (vitest chạy environment 'node', không có DOM).
 */

/** Giây → "12 phút 30 giây". Không có số liệu → "—". */
export const formatDuration = (seconds?: number | null): string => {
  if (seconds === null || seconds === undefined || Number.isNaN(seconds)) return '—';

  const total = Math.max(0, Math.round(seconds));
  const minutes = Math.floor(total / 60);
  const rest = total % 60;

  if (minutes === 0) return `${rest} giây`;
  if (rest === 0) return `${minutes} phút`;
  return `${minutes} phút ${rest} giây`;
};

/**
 * Phần trăm của một nhóm so với tổng lượt, làm tròn 1 chữ số thập phân (đúng như "25.7%" trong
 * tài liệu). Trả null khi không tính được — chỗ hiển thị sẽ ẩn badge thay vì hiện "NaN%".
 */
export const percentOf = (value?: number | null, total?: number | null): number | null => {
  if (value === null || value === undefined) return null;
  if (!total) return null;
  return Math.round((value / total) * 1000) / 10;
};

export interface DailySeries {
  /** Nhãn trục ngang: số ngày trong tháng ("1", "2", …). */
  labels: string[];
  values: number[];
  /** Vị trí cột của hôm nay, -1 nếu hôm nay không thuộc tháng đang xem. */
  todayIndex: number;
}

/**
 * Dựng dữ liệu biểu đồ từ `daily` của API. API đã trả đủ mọi ngày trong tháng (ngày rỗng = 0) nên
 * ở đây KHÔNG tự sinh ngày — giữ đúng thứ tự API trả về.
 */
export const buildDailySeries = (
  daily?: { date: string; visits: number }[] | null,
  todayKey?: string
): DailySeries => {
  if (!daily || daily.length === 0) return { labels: [], values: [], todayIndex: -1 };

  return {
    labels: daily.map((d) => String(Number(d.date.slice(8, 10)))),
    values: daily.map((d) => d.visits),
    todayIndex: todayKey ? daily.findIndex((d) => d.date === todayKey) : -1,
  };
};
